<template>
    <el-dialog title="关联商品" :visible.sync="dialogVisible" width="460px" :before-close="dialogClose"  :close-on-click-modal="false">
        <el-radio v-model="type" label="1">轻养小铺商品</el-radio>
        <el-radio v-model="type" label="2">跳转链接</el-radio>

        <div class="product-content">
            <template v-if="type == 1">
                <el-input :value="productName" readonly placeholder="请选择商品">
                    <template #append>
                        <el-button @click="showProductDialog">添加商品</el-button>
                    </template>
                </el-input>
            </template>
            <template v-if="type == 2">
                <div style="display: flex;align-items: center;margin-bottom: 20px;">
                    <span style="width: 100px;">小程序: </span><el-input v-model="linkUrl" placeholder="请输入mini开头的链接地址"></el-input>
                </div>
                <div style="display: flex;align-items: center">
                    <span style="width: 100px;">APP: </span><el-input v-model="appUrl" placeholder="请输入http开头的链接地址"></el-input>
                </div>
            </template>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogClose">取消</el-button>
            <el-button type="primary" @click="dialogConfirm">提交</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { Component, Vue, Prop } from "vue-property-decorator";

import { wsProductBindMallProduct } from "@/api/wsProduct";

@Component({
    components: {
    }
})
export default class ChooseProductType extends Vue {
    @Prop() chooseProductInfo;
    @Prop() productId;
    @Prop() confirmFn;
    productName = "";

    dialogVisible = false;
    type = "1";

    linkUrl = "";
    appUrl = "";

    showProductDialog() {
        this.$emit("showProductDialog");
    }

    dialogClose() {
        this.dialogVisible = false;
        this.productName = "";
        this.linkUrl = "";
        this.appUrl = "";
    }

    dialogConfirm() {
        const { spu, name } = this.chooseProductInfo || {};
        if (this.confirmFn) {
            this.confirmFn?.({ type: this.type, spu, name, linkUrl: this.linkUrl, appUrl: this.appUrl });
            return;
        }
        const params = {
            id: this.productId,
            spu: this.type == "1" ? spu : undefined,
            linkUrl: this.type == "2" ? this.linkUrl : undefined,
            appUrl: this.type == "2" ? this.appUrl : undefined,
        }
        wsProductBindMallProduct(params).then(() => {
            this.$emit("refreshProductList")
            this.dialogClose();
        })
    }
}

</script>
<style lang="scss" scoped>
@import "@/styles/app";

.product-content{
    margin-top: 20px;
}

:deep(.el-input-group__append){
    background-color: #409EFF;
    color: #fff;
}
</style>